import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/layout/Layout'
import ProtectedRoute from './components/auth/ProtectedRoute'
import LoginPage from './pages/auth/LoginPage'
import RegisterPage from './pages/auth/RegisterPage'
import ScriptListPage from './pages/scripts/ScriptListPage'
import ScriptEditorPage from './pages/scripts/ScriptEditorPage'
import DatasetListPage from './pages/datasets/DatasetListPage'
import DatasetUploadPage from './pages/datasets/DatasetUploadPage'
import DatasetDetailPage from './pages/datasets/DatasetDetailPage'
import JobQueuePage from './pages/jobs/JobQueuePage'
import JobDetailPage from './pages/jobs/JobDetailPage'
import ResultsPage from './pages/results/ResultsPage'
import SettingsPage from './pages/settings/SettingsPage'
import PapersListPage from './pages/papers/PapersListPage'
import PaperDetailPage from './pages/papers/PaperDetailPage'
import BacktestConfigPage from './pages/backtest/BacktestConfigPage'
import BacktestRunPage from './pages/backtest/BacktestRunPage'
import MultiSymbolAnalysisPage from './pages/MultiSymbolAnalysisPage'
import { Toaster } from './components/ui/toaster'
import { useAuthStore } from './store/authStore'
import { ThemeProvider } from './hooks/useTheme'

function App() {
  const { initialize } = useAuthStore()

  useEffect(() => {
    // Initialize Supabase Auth and check authentication on app mount
    initialize()
  }, [initialize])

  return (
    <ThemeProvider defaultTheme="system" storageKey="quantquack-ui-theme">
      <Routes>
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/register" element={<RegisterPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/scripts" replace />} />
          <Route path="scripts" element={<ScriptListPage />} />
          <Route path="scripts/new" element={<ScriptEditorPage />} />
          <Route path="scripts/:id" element={<ScriptEditorPage />} />
          <Route path="datasets" element={<DatasetListPage />} />
          <Route path="datasets/upload" element={<DatasetUploadPage />} />
          <Route path="datasets/:id" element={<DatasetDetailPage />} />
          <Route path="jobs" element={<JobQueuePage />} />
          <Route path="jobs/:id" element={<JobDetailPage />} />
          <Route path="results/:id" element={<ResultsPage />} />
          <Route path="papers" element={<PapersListPage />} />
          <Route path="papers/:id" element={<PaperDetailPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="backtest/configure" element={<BacktestConfigPage />} />
          <Route path="backtest/run" element={<BacktestRunPage />} />
          <Route path="multi-symbol" element={<MultiSymbolAnalysisPage />} />
        </Route>
      </Routes>
      <Toaster />
    </ThemeProvider>
  )
}

export default App
